// Libs
import React, { useEffect, useRef } from "react";
import { useHistory } from "react-router";
import { bindActionCreators } from "redux";
import { connect, useSelector } from "react-redux";
import { css } from "emotion";
import moment from "moment";

// Utilities and config
import bookingStatus from "../../../config/bookingStatus";
import { useAsyncDebounce } from "../../../utilities/useAsyncDebounce";
import { useDebouncedCallback } from "use-debounce";

// Components
import FinishedBooking from "../FinishedBooking";
import Spinner from "../../ui/Spinner";
import InfiniteScroll from "react-infinite-scroller";

// Actions
import { getBookings, resetBookings, changeWeekNumber, changeTab } from "../../../actions/bookingActions";

// Styles
import colors from "../../../styles/colors";
import ErrorBox from "../../ui/ErrorBox";
import { breakPoint } from "../../../styles/breakPoints";
import ArrowLeftCircleIcon from "mdi-react/ArrowLeftCircleIcon";
import ArrowRightCircleIcon from "mdi-react/ArrowRightCircleIcon";
import tinycolor from "tinycolor2";

const FinishedBookings = props => {
  const { bookings, loading, error, tab, weekNumber, weekNumberToDisplay } = useSelector(
    state => state.booking.finished
  );

  const startDate = moment(moment().week(weekNumber).startOf("week")).format("DD");
  const endDate = moment(moment().week(weekNumber).endOf("week")).format("DD");

  const {changeTab, changeWeekNumber} = props;
  useEffect(() => {
    props.resetBookings({type: 'finished'})
    getBookingDetails();
  }, [tab, weekNumber]);

  // Gets the information on the site
  const [getBookingDetails] = useDebouncedCallback(async () => {
    try {
      let currentWeek = tab == 0 ? 0 : weekNumber;
      props.getBookings({ type: bookingStatus.finished, weekNumber: currentWeek });
    } catch (error) {
      props.addToast({
        message: "Noget gik galt. Kunne ikke hente information..",
        type: "error",
        autoDismiss: true,
      });
    }
  }, 100);

  // const debouncedGetBookings = useAsyncDebounce(props.getBookings, 250);

  // useEffect(() => {
  //   props.resetBookings();
  //   props.getBookings({ type: bookingStatus.finished });
  //   // ComponentWillUnmount
  //   return () => {
  //     props.resetBookings();
  //   };

  //   // eslint-disable-next-line
  // }, []);
  return (
    <div className={componentStyle(colors)} >
      <div className="tab-navigator">
        <div className="wrapper">
          <button
            onClick={() => changeTab({bookingType: 'finished', tab: 0})}
            className={`${tab === 0 ? "active" : ""}`}
          >
            LISTE
          </button>
          <button
            onClick={() => changeTab({bookingType: 'finished', tab: 1})}
            className={`${tab === 1 ? "active" : ""}`}
          >
            VIS UGE
          </button>
        </div>
        {tab === 1 && (
          <div className="week-wrapper">
            <ArrowLeftCircleIcon
              onClick={() => {
                  let visibleWeekNumber = weekNumberToDisplay == 1 ? 52 : weekNumberToDisplay - 1;
                  changeWeekNumber({
                    weekNumber: weekNumber - 1,
                    weekNumberToDisplay: visibleWeekNumber,
                    bookingType: 'finished'
                  });
              }}
            />
            <p>{`UGE ${weekNumberToDisplay} (${startDate}-${endDate})`}</p>
            <ArrowRightCircleIcon
              onClick={() => {
                  let visibleWeekNumber = weekNumberToDisplay == 52 ? 1
                      : weekNumberToDisplay + 1;
                  changeWeekNumber({
                    weekNumber: weekNumber + 1,
                    weekNumberToDisplay: visibleWeekNumber,
                    bookingType: 'finished'
                  });
              }}
            />
          </div>
        )}
      </div>
      {/* {loading && !error && bookings.length == 0 && <Spinner title={"Henter bookinger..."} />} */}
      {!loading && error && <ErrorBox />}

      {!loading && !error && bookings.length === 0 && (
        <div className="no-bookings-container">
          <p>Der er ikke nogen bookings som mangler at blive checked ud</p>
        </div>
      )}


                <InfiniteScroll
                  loadMore={() => {
                    if(tab == 0){
                      console.log("load more")
                      getBookingDetails({
                        type: bookingStatus.finished
                      })
                    }
                  }
                  }
                  hasMore={true}
                  useWindow={false}
                >
                {bookings.length > 0 &&
                  bookings.map((booking, index) => (
                    <div key={`booking-index-${index}`}>
                      <FinishedBooking className="finished-booking" booking={booking} selectedShifts={booking.selectedShifts} />
                    </div>
                  ))}
          {loading && (
            <Spinner
              title={"Indlæser bookinger..."}
              style={{ margin: "2rem 0" }}
            />
          )}

        </InfiniteScroll>

    </div>
  );
};

const componentStyle = () => css`
  width: 100%;
  height: 100%;
  .tab-navigator {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    margin-top: 1rem;

    .wrapper {
      position: relative;
      display: inline-block;
      border: 1px solid ${colors.primeBlue};
      border-radius: 3px;
      padding: 0.5rem;
      margin-bottom: 1rem;

      button {
        outline: none;
        padding: 0.35rem 0.75rem;
        font-weight: 500;
        border-radius: 3px;

        &.active {
          background-color: ${colors.primeBlue};
          color: ${colors.white};
          padding: 0.35rem 0.6rem;
        }
      }
    }

    .week-wrapper {
      display: flex;
      align-items: center;
      justify-content: center;

      p {
        padding: 0 1rem;
        font-weight: bold;
        color: ${colors.primeBlue};
      }
      svg {
        height: 2rem;
        width: 2rem;
        fill: ${colors.primeBlue};
        cursor: pointer;

        &:active {
          fill: ${tinycolor(colors.primeBlue).darken(5).toString()};
        }
      }
    }
  }

  .finished-booking {
    min-height: 9rem;
    @media screen and (max-width: ${breakPoint.sm}px) {
      min-height: 5.5rem;
    }
  }

  .no-bookings-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    p {
      font-weight: 500;
    }
  }
`;

const mapDispatchToProps = dispatch => ({
  getBookings: bindActionCreators(getBookings, dispatch),
  resetBookings: bindActionCreators(resetBookings, dispatch),
  changeWeekNumber: bindActionCreators(changeWeekNumber, dispatch),
  changeTab: bindActionCreators(changeTab, dispatch),
});

export default connect(null, mapDispatchToProps)(FinishedBookings);
